import ContactPage from "../Components/Contact/ContactPage.tsx";

const Contact = () => {
  return <ContactPage />;
};

export default Contact;
